import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, Input, Tooltip } from "reactstrap";
import { handleChangePassword } from "../../../Component/Admin/Admin/AdminUtils";

const ChangePassword = () => {
    const [modal, setModal] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const toggleTooltip = () => setTooltipOpen(prev => !prev);
    const toggle = () => setModal(prev => !prev);

    const validatePassword = () => {
        let errors = [];
        if (newPassword !== confirmPassword) {
            errors.push("Password baru dan konfirmasi password tidak sama.");
        }
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()])[A-Za-z\d@$!%*?&#^()]{8,}$/;
        if (!regex.test(newPassword)) {
            errors.push("Password baru harus mengandung huruf kecil, huruf besar, angka, karakter spesial, dan minimal 8 karakter.");
        }
        return errors;
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        setModal(true);
        const errors = validatePassword();
        if (errors.length > 0) {
            setErrorMessages(errors);
            setIsLoading(false);
            return;
        }

        const payload = { old_password: oldPassword, new_password: newPassword };
        const response = await handleChangePassword(payload);
        if (response.status === 'success') setModal(false);
        setIsLoading(false);
        setErrorMessages([]);
    };

    return (
        <div>
            <Button color="warning" onClick={toggle} size="sm" id="Tooltip-1">
                Ganti Password <i className="icon-arrow-right"></i>
            </Button>
            <Tooltip placement="top" isOpen={tooltipOpen} target="Tooltip-1" toggle={toggleTooltip}>
                Ganti Password
            </Tooltip>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalBody>
                    {[{ label: "Old Password", state: oldPassword, setter: setOldPassword },
                      { label: "New Password", state: newPassword, setter: setNewPassword },
                      { label: "Confirm Password", state: confirmPassword, setter: setConfirmPassword }]
                      .map(({ label, state, setter }, idx) => (
                          <div className="form-group" key={idx}>
                              <label>{label}</label>
                              <Input
                                  type={isShowPassword ? "text" : "password"}
                                  className="form-control"
                                  value={state}
                                  onChange={(e) => setter(e.target.value)}
                              />
                          </div>
                      ))}
                    <div className="show-hide" onClick={() => setIsShowPassword(prev => !prev)}>
                        <span className={isShowPassword ? "hide" : "show"}></span>
                    </div>
                    {errorMessages.length > 0 && (
                        <div className="alert alert-danger mt-2">
                            <ul>{errorMessages.map((msg, i) => <li key={i}>* {msg}</li>)}</ul>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="warning" onClick={toggle}>Close</Button>
                    <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
                        {isLoading ? "Loading..." : "Submit"}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ChangePassword;
